<template>
<div class="container bookList">
<div class="text--center m4u_text--text">
  <p class="pageHeading text-center" v-if="!$vuetify.breakpoint.xs">Invite a friend to join Memories For Us</p>
  <p class="pageHeading text-center" v-if="$vuetify.breakpoint.xs">Invite a friend to join</p>
  <p class="pageHeading text-center" v-if="$vuetify.breakpoint.xs"> Memories For Us</p>
  <p class="pageHeading" v-if="(user.UserSubType !== 2 && user.UserSubType !== 3)">
    <!-- Get a free month when they sign up for a paid account! -->
    Memories For Us is still in beta. We will notify you when we can offer subscriptions to more of your friends and family. 
    </p>
  <p class="pageHeading" v-if="(user.UserSubType === 2 || user.UserSubType === 3) && freeInvitations <= 0">
    <!-- Get a free month when they sign up for a paid account! -->
    You have used all of your free for life invitations. Memories For Us is still in beta. We will notify you when we can offer subscriptions to more of your friends and family. 
    </p>
  <p class="pageSubHeading" v-if="(user.UserSubType === 2 || user.UserSubType === 3) && freeInvitations > 0">You have {{freeInvitations}}  more "free for life" invitations to share!</p>
   <v-form v-model="valid" ref="form" lazy-validation class="m4u_tertiary">
    <v-container  v-if="(user.UserSubType === 2 || user.UserSubType === 3) && freeInvitations > 0">
      <v-card class="m4u_tertiary">
        <v-card-text>
      <h3 class="m4u_text--text">Who do you want to invite?</h3>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
          color="m4u_text"
            v-model="invitee"
            :rules="nameRules"
            :counter="50"
            label="Name of the person to invite"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      {{message}}
      </v-card-text>
      <v-btn class="primary m4u_text--text ml-3 mb-2" @click="sendInvitation()">Invite</v-btn>
      </v-card>
    </v-container>
  </v-form>
</div>
</div>
</template>
<script>

import EventService from '@/services/EventService.js'; 

export default {
 name: "Invitation",
  data() {
    return {

        tcMonth: '',
        tcDay: '',
        tcYear: '',
        tcDate: '',
        valid: false,
      invitee: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 50 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      message: '',
      freeInvitations: ''
       }
    },
  
  components: {

  },
  
mounted() {
  this.setUpDate();
  this.getFreeInvitations();
  },


computed: {
  user(){
    return this.$store.state.user
  },

  loginState(){
    return this.$store.state.loginState
  },

},

  methods: {
      async sendInvitation() {
        this.message = '';
      await EventService.sendInvitation(this.user.UserID, this.invitee, this.email, this.tcDate, this.user.UserDisplayName, this.user.UserSubType)
      .then(
        (invitationreturn => {
          if(invitationreturn.data === 'Duplicate'){
            this.message = 'You have already invited this person.'
          } else if (invitationreturn.data === 'Member') {
            this.message = 'This person is already a member. You can invite them to your circles.'
          }
          else {
            this.message = 'Your invitation to ' + this.invitee + ' has been sent.';
            this.invitee = '';
            this.email = '';
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
          }
        })
      )
      .then((sendInvitationReturn) => {
        this.getFreeInvitations()
      });

    },

      async getFreeInvitations() {
      await EventService.getFreeInvitations(this.user.UserID, this.user.UserSubType)
      .then(
        (freereturn => {
          this.freeInvitations = freereturn
        })

      );
    },

    async setUpDate() {
      var dateObj = new Date();
      this.tcMonth = dateObj.getUTCMonth() + 1; //months from 1-12
      if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
      this.tcDay = dateObj.getUTCDate();
       if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcYear = dateObj.getUTCFullYear();
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
    }
  }

}


</script>
<style lang="scss" scoped>

  .formCard {
    max-width: 90%;
    justify-content: center;
  }

  .pageHeading {
    font-size: 1.25em;

  }

  .pageSubHeading {
    font-size: 1em;
  }

  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }


</style>